/**
 * Use this as a shortcut method for Prototypal inheritance.
 */

Object.instantiate= function(o) {
    function F() {}
    F.prototype = o;
    return new F();
};

var JV = JV || {};
JV.JH = JV.JH || {};
JV.JH.Model = {

        scope: {},
        xhr:{},
        destkey : '',


        /**
         * Create your model hierarchy.
         */
        create: function(){
            var object = Object.instantiate(this);
            object.parent = this;
            object.prototype = object.fn = Object.instantiate(this.prototype);
            return object;
        },

        /*
         * Add properties to your model instance.
         */
        extend: function(o){
            jQuery.extend(this, o);
        },

        /**
         * To be implemented.
         *
         * Posts the model of your page to the remote server.
         */
        save: function(url, success, error){
            this.preSave();
            this.postSave();
        },

        /**
         * Fetches the data needed for the controller and attaches it to the scope's destkey property.
         */
        fetch: function(settings){
            var self = this;
            settings = angular.extend({
                error: function(response, code){
                    alert('There was an error processing the request. Please refresh the page and try again.');
                },
                success: function(res, code){
                    var response = res.data;
                    if(response.toString().indexOf('window.location') > 0) {
                        eval(response);
                    }else{
                        if(settings && settings.sourceKey){
                            response = response[settings.sourceKey];
                        }
                        if(settings && settings.destkey){
                            self.scope[settings.destkey] = response;
                        }else if(self.destkey){
                            self.scope[self.destkey] = response;
                        }
                        self.postFetch();
                    }
                },
                data: {}
            }, settings);
            this.preFetch(settings);
            this.xhr.get(settings.url, {params:settings.data}).then(settings.success, settings.error);
        },

        // Below methods are hooks for subclasses to override. For ex: Could be used for serialization/Deserialization.
        // If you need any generic functionality for these methods, you can put them in here and invoke them using parent.xxxxxxx

        preFetch: function(){

        },

        postFetch: function(){

        },

        preSave: function(){

        },

        postSave: function(){

        }

};
